import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45a5dce2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup__title" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","gap":"10px","justify-content":"space-between"} }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "error-text mb-2"
}
const _hoisted_5 = {
  key: 1,
  class: "cashback-info"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "or-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "or-line" }),
  /*#__PURE__*/_createTextVNode(" OR "),
  /*#__PURE__*/_createElementVNode("div", { class: "or-line" })
], -1))
const _hoisted_7 = { style: {"display":"flex","align-items":"center","gap":"10px","justify-content":"space-between"} }
const _hoisted_8 = { style: {"font-size":"20px"} }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["innerHTML"]

import PopupTemplate from "@/components/popups/PopupTemplate.vue";
import {
  ref,
  Ref,
  watch,
  ComputedRef,
  computed,
} from "vue";
import { useEsimStore } from "@/stores/esim";
import { useAppStore } from "@/stores/app";
import MainLoader from "@/components/MainLoader.vue";
import { useUserStore } from "@/stores/user";
import { useDataStore } from "@/stores/data";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupPromo',
  props: { bundlePrice: Number },
  emits: ["promo", "cashback"],
  setup(__props) {

const props = __props;


const esimStore = useEsimStore();
const appStore = useAppStore();
const userStore = useUserStore();
const dataStore = useDataStore();

const promoCode: Ref<string> = ref("");
const promoInvalid: Ref<boolean> = ref(false);
const promoLoading: Ref<boolean> = ref(false);

const checkPromo = async () => {
  promoLoading.value = true;

  esimStore.activePromo = await esimStore.checkPromoIsValid(promoCode.value);
  promoInvalid.value = !esimStore.activePromo;

  promoLoading.value = false;

  if (esimStore.activePromo) {
    esimStore.useCashback = false;
    appStore.closePopup();
  }
};

const useCashback = () => {
  esimStore.useCashback = true;
  esimStore.activePromo = null;
  appStore.closePopup();
};

watch(promoCode, () => (promoInvalid.value = false));

const maxUsedCashback: ComputedRef<number> = computed(() => {
  const userCashback: number = userStore.cashback;

  const maxBundle: number = Math.round(
    (props.bundlePrice / 100) *
      (100 - dataStore.minTransactionPriceWithCashbackPercents)
  );

  if (maxBundle > userCashback) {
    return userCashback;
  }

  return maxBundle;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupTemplate, null, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, " Enter promo code" + _toDisplayString(_unref(dataStore).showCashback ? " or rewards" : ""), 1),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((promoCode).value = $event)),
          type: "text",
          class: "form-control mt-3 mb-3",
          placeholder: "Promo code"
        }, null, 512), [
          [_vModelText, promoCode.value]
        ]),
        _createElementVNode("button", {
          class: "btn btn-b btn-max btn-danger use-promo-button",
          disabled: promoLoading.value || promoInvalid.value || !promoCode.value.trim().length,
          onClick: checkPromo
        }, [
          _createTextVNode(" Use "),
          (promoLoading.value)
            ? (_openBlock(), _createBlock(MainLoader, { key: 0 }))
            : _createCommentVNode("", true)
        ], 8, _hoisted_3)
      ]),
      (promoInvalid.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Promo code is invalid"))
        : _createCommentVNode("", true),
      (_unref(dataStore).showCashback)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, " Apply $" + _toDisplayString((maxUsedCashback.value / 100).toLocaleString("en-US")) + " in rewards ", 1),
              _createElementVNode("button", {
                class: "btn btn-b btn-max btn-danger apply-rewards-button",
                onClick: useCashback,
                disabled: promoLoading.value
              }, " Apply ", 8, _hoisted_9)
            ]),
            _createElementVNode("div", {
              class: "cashback-info__label",
              innerHTML: _unref(dataStore).minPaymentTermsText
            }, null, 8, _hoisted_10)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})